import { SFDateRangePicker } from "../../../datePicker";
import {
  getUtcDateTime,
  getMonthDayYearDate,
} from "../../../../services/dateService";
import { GRID_FILTERS } from "../../dataGridConfig";

const DateRenderer = ({
  config,
  generatedFilter,
  colDef,
  colId,
  onChange,
  onError,
}) => {
  // Calculate the current filter based on the filtering type
  // Ag-grid uses 'dateFrom' property as the primary filter
  // even when the type is 'lessThan' and 'dateTo' as the secondary
  // filter used for 'inRange' type
  let selectedValues;
  switch (generatedFilter?.type) {
  case GRID_FILTERS.type.inRange:
    selectedValues = {
      dateFrom: generatedFilter.dateFrom,
      dateTo: generatedFilter.dateTo,
    };
    break;
  case GRID_FILTERS.type.greaterThan:
    selectedValues = {
      dateFrom: generatedFilter.dateFrom,
      dateTo: null,
    };
    break;
  case GRID_FILTERS.type.lessThan:
    selectedValues = {
      dateFrom: null,
      dateTo: generatedFilter.dateFrom,
    };
    break;
  default:
    selectedValues = {
      dateFrom: null,
      dateTo: null,
    };
  }

  const handleChange = ({ dateFrom, dateTo }) => {
    if (!dateFrom && !dateTo) return onChange(null);

    onChange({ dateFrom, dateTo });
  };

  return (
    <SFDateRangePicker
      values={selectedValues}
      onChange={handleChange}
      label={colDef.headerName}
      // This determines the date format that is used
      // when the component calls the onChange function
      dateFormatter={(x) => getUtcDateTime(getMonthDayYearDate(x))}
      disablePortal
      preventUserInput
    />
  );
};

export default DateRenderer;
